export default __webpack_public_path__ + "static/media/choicecuts.e79368fd.jpg";